<template>
    <div class="upi-title">
        <label>{{$t('add-your','Add your')}} <span>{{paymentMethod?.method_type == 'upi' ? $t('upi','UPI') : $t('wallet','Wallet')}}</span> {{$t('account-details','Account Details')}}</label>
    </div>
    <div class="back-modal hide-input-sec">
        <div class="upi-main number-sec1 row">
            <div class="number-header col-12">
                <label>{{$t('account-holder-name','Account holder’s name')}}* </label>
                <input v-model="upiDetails.account_holder_name" class="form-control profit-input" type="text" placeholder="Enter Account Holder Name" />
                <div class="error-messages-text" v-if="v$.upiDetails.account_holder_name.$error">
                    <template v-if="v$.upiDetails.account_holder_name.required.$invalid">
                        <p>{{$t('please-enter-name','Account holder name is required.')}}</p>
                    </template>
                    <template v-else-if="v$.upiDetails.account_holder_name.minLength.$invalid || v$.upiDetails.account_holder_name.maxLength.$invalid">
                        <p>{{$t('min-characters','Account holder name must be 3-100 characters.')}}</p>
                    </template>
                    <template v-if="v$.upiDetails.account_holder_name.alphaName.$invalid">
                        <p>{{$t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.')}}</p>
                    </template>
                </div>
            </div>

            <div class="number-header col-12">
                <label>{{ paymentMethod?.method_type == 'upi' ? $t('upi-id','Upi ID') : $t('wallet-id','Wallet ID*') }}</label>
                <input v-model="upiDetails.upi_id" class="form-control profit-input" type="text" :placeholder="paymentMethod?.method_type == 'upi' ? 'Enter UPI ID' : 'Enter Wallet ID' " />
                <div class="error-messages-text" v-if="v$.upiDetails.upi_id.$error">
                    <template v-if="v$.upiDetails.upi_id.required?.$invalid && paymentMethod?.method_type != 'upi'">
                    {{ $t('wallet-required','Wallet ID is required.') }}
                    </template>
                    <template v-else-if="v$.upiDetails.upi_id.minLength.$invalid || v$.upiDetails.upi_id.maxLength.$invalid">
                    {{ paymentMethod?.method_type == 'upi' 
                        ? $t('upi-length','UPI ID must be 5 to 50 characters.') 
                        : $t('wallet-length','Wallet ID must be 8 to 20 characters.') }}
                    </template>

                    <template v-if="paymentMethod?.method_type == 'upi' && v$.upiDetails.upi_id.upiValidator.$invalid">
                    {{$t('upi-format','Must be in the format of name@bank.')}}
                    </template>
                    <template v-if="paymentMethod?.method_type != 'upi' && v$.upiDetails.upi_id.walletValidator.$invalid">
                    {{$t('wallet-format','Wallet ID can only include letters, numbers, @, hyphens, or underscores')}}
                    </template>
                </div>
            </div>
            <div class="number-header col-12">
                <label>
                    {{$t('qr-code-upload-screenshot','Qr code (upload screenshot)')}}
                    <span class="info-sec-icon">
                        <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy" />
                        <div class="info-list info-main">
                            <ul>
                                <li>1. Upload A Screenshot Of A Valid QR Code To Proceed.</li>
                                <li>2. If the QR code is not detected, the exchange will not be responsible for the losses.</li>
                            </ul>
                        </div>
                    </span>
                </label>
                <div class="file-upload-sec show" v-if="!previewImage">
                    <label for="file" class="file-upload show">
                        <span><img src="@/assets/images/file-icon.svg" alt="file-icon" loading="lazy" /></span>

                        <h6 class="text-dark">{{$t('file-upload','File Upload')}}</h6>
                    </label>
                    <input class="form-control profit-input d-none" type="file" @change="onUploadImage($event)" name="file" multiple="" id="file" />
                </div>
                <div class="fileList" v-if="previewImage">
                    <img loading="lazy" class="fileList-img" :src="previewImage" alt="file-list"/>
                    <button class="add-utr-again" @click="removeImage()">
                        &#10006;
                    </button>
                </div>
            </div>
            <div class="number-header">
                <label>{{$t('withDraw-password','Withdraw Password')}}* </label>
                <div class="password-field-rel">
                    <input v-model="upiDetails.withdrawal_password" :type="withdrawPasswordFieldType" class="form-control" placeholder="Enter Withdraw Password" />
                    <div class="showHide-icon" @click="togglePasswordVisibility('withdrawPassword')">
                        <i v-if="withdrawPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                        <i v-else aria-hidden="true" class="fa fa-eye"></i>
                    </div>
                </div>
                <div class="error-messages-text" v-if="v$.upiDetails.withdrawal_password.$error">{{$t('please-enter-withdraw-password','Please Enter Withdraw Password')}}</div>
            </div>

            <div class="number-header col-12 mb-2 text-right">
                <a @click="forgetWithdrawModal()" class="forgot_withdraw_cl">{{$t('forgot-withDraw-password','Forgot Withdraw Password')}}?</a>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength, maxLength, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core';
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const upiValidator = helpers.withMessage(
  "Must be in the format of 'name@bank.'",
  (value) => {
    if (!value) return true
    return /^[A-Za-z0-9]+@[A-Za-z0-9]+$/.test(String(value))
  }
)
const walletValidator = helpers.withMessage(
  'Must contain only letters, numbers, @, hyphens, or underscores.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    return /^[A-Za-z0-9_@-]+$/.test(String(value))
  }
)

export default {
    name: 'AddBankAccount',
    setup() {
		return { v$: useVuelidate() }
	},
    data() {
        return {
            previewImage: null,
            withdrawPasswordFieldType : 'password',
        }
    },
    props:['upiDetails', 'paymentMethod'],
    emits:['forget-withdraw-password'],
    validations() {
        const isUpi = this.paymentMethod?.method_type === 'upi'
        return{
            upiDetails: {
                account_holder_name: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName
                },
                upi_id: { 
                    ...(isUpi ? { } : { required }),
                    minLength: minLength(isUpi ? 5 : 8),
                    maxLength: maxLength(isUpi ? 50 : 20),
                    ...(isUpi ? { upiValidator } : { walletValidator })
                },
                withdrawal_password: { required }
            },
        }
        
    },
    methods:{
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'withdrawPassword'){
                this.withdrawPasswordFieldType = this.withdrawPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        forgetWithdrawModal(){
            this.$emit('forget-withdraw-password')
        },
        onUploadImage(event){
            const file = event.target.files[0];
            const maxFileSize = 5 * 1024 * 1024; 
            if (file.size > maxFileSize) {
                event.target.value = "";
                this.$errorToast(`Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.`)
                return
            }
            if (!file.type.startsWith('image/')) {
                event.target.value = "";
                this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                return;
            }
            this.previewImage = URL.createObjectURL(file)
            this.upiDetails.qr_code = file
        },
        removeImage(){
            this.upiDetails.qr_code = null
            this.previewImage = null
        },
    }
}
</script>